import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const CheckGraphic: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = 'black',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.07759 8.12069C3.07759 5.33546 5.33546 3.07759 8.12069 3.07759H16.6552C17.2979 3.07759 17.819 2.55654 17.819 1.91379C17.819 1.27105 17.2979 0.75 16.6552 0.75H8.12069C4.04997 0.75 0.75 4.04997 0.75 8.12069V15.8793C0.75 19.95 4.04997 23.25 8.12069 23.25H17.7635C20.7936 23.25 23.25 20.7936 23.25 17.7635V10.4483C23.25 9.80553 22.729 9.28448 22.0862 9.28448C21.4435 9.28448 20.9224 9.80553 20.9224 10.4483V17.7635C20.9224 19.5081 19.5081 20.9224 17.7635 20.9224H8.12069C5.33546 20.9224 3.07759 18.6645 3.07759 15.8793V8.12069ZM22.8982 5.85097C23.3586 5.40253 23.3684 4.66572 22.9199 4.20526C22.4715 3.74481 21.7347 3.73507 21.2742 4.18351L12.9101 12.3294C12.7487 12.4866 12.4877 12.4737 12.3426 12.3012L9.01125 8.34131C8.59748 7.84946 7.86333 7.78618 7.37148 8.19995C6.87964 8.61373 6.81635 9.34788 7.23012 9.83972L10.5615 13.7996C11.577 15.0068 13.404 15.0975 14.5341 13.9969L22.8982 5.85097Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckGraphic;
